import { useMemo } from 'react';
import T from 'prop-types';
import { isNil } from 'lodash';
import { Editor, EditorState, ContentState, convertFromRaw } from 'draft-js';

import styles from './Description.scss';

function negotiateContent(content) {
    if (isNil(content)) {
        return EditorState.createWithContent(ContentState.createFromText(' '));
    } else if (typeof content === 'string') {
        try {
            let rawContentState = JSON.parse(content);
            return EditorState.createWithContent(rawContentState);
        } catch (e) {
            return EditorState.createWithContent(ContentState.createFromText(content));
        }
    } else {
        try {
            let contentState = convertFromRaw(content);
            return EditorState.createWithContent(contentState);
        } catch (e) {
            return EditorState.createWithContent(ContentState.createFromText(' '));
        }
    }
}

export const Description = ({ content = '' }) => {
    const editorState = useMemo(() => {
        if (content) {
            return negotiateContent(content);
        } else {
            return EditorState.createEmpty();
        }
    }, [content]);

    return (
        <div className={styles.Description} data-cy="Description">
            <Editor editorState={editorState} readOnly={true} />
        </div>
    );
};

Description.propTypes = {
    content: T.oneOfType([
        T.string,
        T.object
    ])
};

export default Description;
